<template>
	<div class="student-avatar" :style="avatarStyle">
		<img v-if="src && !loadFailed" :src="src" @error="loadFailed = true" alt="">
		<span v-else class="student-avatar__text" :class="`student-avatar__text--${colorIndex}`">{{ avatarName }}</span>
	</div>
</template>

<script>
	export default {
		props: {
			avatar: [String, Number],
			name: [String, Number],
			userId: [String, Number],
			gender: [String, Number],
			size: {
				type: [String, Number],
				default: 44,
			},
		},
		data() {
			return {
				loadFailed: false,
			}
		},
		computed: {
			avatarStyle() {
				const size = typeof this.size === 'number' ? `${this.size}px` : this.size
				return { width: size, minWidth: size, height: size, minHeight: size }
			},
			src() {
				if (this.avatar) return this.avatar
				const userId = String(this.userId || '')
				const lastDigit = userId.slice(-1)
				const userIdNumber = Number(userId)
				if (!/^\d$/.test(lastDigit) || Number(lastDigit) < 4 || !Number.isFinite(userIdNumber)) return ''

				const baseUrl = 'https://new-shengxue985.oss-cn-hangzhou.aliyuncs.com/2026/01/05'
				if (Number(this.gender) === 2) return `${baseUrl}/nv${userIdNumber % 25}.png`
				if (Number(this.gender) === 1) return `${baseUrl}/nan${userIdNumber % 21}.png`
				return `${baseUrl}/wu${userIdNumber % 9}.png`
			},
			avatarName() {
				return String(this.name || '').slice(-2)
			},
			colorIndex() {
				let colorIndex = 0
				const name = String(this.name || '')
				for (let index = 0; index < name.length; index += 1) {
					colorIndex = (colorIndex + name.charCodeAt(index)) % 5
				}
				return colorIndex
			},
		},
		watch: {
			src() {
				this.loadFailed = false
			},
		},
	}
</script>

<style scoped>
.student-avatar { display: flex; flex: 0 0 auto; align-items: center; justify-content: center; overflow: hidden; box-sizing: border-box; border-radius: 50%; }
.student-avatar img, .student-avatar__text { display: block; width: 100%; min-width: 100%; height: 100%; min-height: 100%; border-radius: inherit; }
.student-avatar img { object-fit: cover; }
.student-avatar__text { display: flex; align-items: center; justify-content: center; overflow: hidden; font-size: 14px; font-weight: 500; line-height: 1; white-space: nowrap; }
.student-avatar__text--0 { background: #e8eeff; color: #1765e6; }
.student-avatar__text--1 { background: #fff4e5; color: #ff7629; }
.student-avatar__text--2 { background: #e5f9ea; color: #27b866; }
.student-avatar__text--3 { background: #f1eaff; color: #8957dc; }
.student-avatar__text--4 { background: #ffe9ef; color: #e2567d; }
</style>
